/* RESPONSIBLE TEAM: team-standalone */

import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type NavbarCollapsingService from 'embercom/services/navbar-collapsing-service';
import type InboxSidebarService from 'embercom/services/inbox-sidebar-service';
import type InboxState from 'embercom/services/inbox-state';
import { SidebarViewType } from 'embercom/services/inbox-state';
import { getOwner } from '@ember/application';
import type ApplicationInstance from '@ember/application/instance';
import type Controller from '@ember/controller';

export default class SuiteMigrationService extends Service {
  @tracked forceSuiteVersion = false;
  @service declare navbarCollapsingService: NavbarCollapsingService;
  @service declare inboxSidebarService: InboxSidebarService;
  @service declare inboxState: InboxState;
  @service declare appService: { app: $TSFixMe };

  get appsController() {
    let owner = getOwner(this) as ApplicationInstance;
    return owner.lookup('controller:apps/app') as Controller & { showPrimaryNav: boolean };
  }

  setForceSuiteVersion(value: boolean) {
    this.forceSuiteVersion = value;

    // If forcing suite, reset the app state to show the nav bar and sidebars
    if (value) {
      this.appsController.set('showPrimaryNav', true);
      this.navbarCollapsingService.set('collapsed', false);
      this.inboxSidebarService.isSidebarCollapsed = false;
      this.inboxState.activeSidebarView = SidebarViewType.InboxList;

      localStorage.setItem('force-suite-version', 'true');
    } else {
      localStorage.setItem('force-suite-version', 'false');
    }
  }

  ensureForceSuiteVersionIsLoaded() {
    if (localStorage.getItem('force-suite-version') === 'true') {
      this.forceSuiteVersion = true;
    } else {
      this.forceSuiteVersion = false;
    }
  }
}
